import { useCallback, useState } from "react";
import dayjs from "dayjs";

const STORAGE_PREFIX = "compass.newsSeenAt.";
const FIRST_VISIT_NEW_DAYS = 7;

const readSeenAt = (compassCid: string): string => {
  const stored = window.localStorage.getItem(`${STORAGE_PREFIX}${compassCid}`);
  if (stored && dayjs(stored).isValid()) return stored;
  return dayjs().subtract(FIRST_VISIT_NEW_DAYS, "day").toISOString();
};

export const useNewsSeenAt = (
  compassCid: string
): { seenAt: string; markSeen: () => void } => {
  const [seenAt, setSeenAt] = useState<string>(() => readSeenAt(compassCid));

  const markSeen = useCallback((): void => {
    const now = dayjs().toISOString();
    window.localStorage.setItem(`${STORAGE_PREFIX}${compassCid}`, now);
    setSeenAt(now);
  }, [compassCid]);

  return { seenAt, markSeen };
};
